<script setup lang="ts">
import { useForwardExpose } from "reka-ui";
import type { InputHTMLAttributes } from "vue";
import { htmlAttrs } from "../../lib/utils";
import Input, { type InputProps } from "./Input.vue";

interface Props
	extends InputProps,
		/* @vue-ignore */ Omit<InputHTMLAttributes, keyof InputProps | "type"> {}

const props = defineProps<Props>();

const model = defineModel<string>();

const { forwardRef } = useForwardExpose();
</script>

<template>
	<Input
		:ref="forwardRef"
		v-model="model"
		:type="($attrs.type as string) || 'text'"
		v-bind="{ ...props, ...htmlAttrs($attrs) }"
	/>
</template>
